module.exports = {"320703001":"墟沟街道","320703003":"连云街道","320703004":"云山街道","320703005":"板桥街道","320703006":"连岛街道","320703007":"徐圩街道","320703008":"海州湾街道","320703009":"宿城街道","320703010":"高公岛街道","320703203":"前三岛乡","320703400":"连云港碱厂","320703401":"东辛农场","320703402":"连云经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320703.json
// module id = 985
// module chunks = 0